import { render, staticRenderFns } from "./CharteFbModal.vue?vue&type=template&id=66fe8d68&scoped=true&"
import script from "./CharteFbModal.vue?vue&type=script&lang=js&"
export * from "./CharteFbModal.vue?vue&type=script&lang=js&"
import style0 from "./CharteFbModal.vue?vue&type=style&index=0&id=66fe8d68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fe8d68",
  null
  
)

export default component.exports